module.exports = __webpack_public_path__ + "static/media/supernatural.a3f72387.mp3";